import _slicedToArray from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { compile, compileG } from "./internal/codegen";
import { vop } from "./internal/vop";

var tpl = function tpl(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      a = _ref2[0],
      b = _ref2[1];

  return "t=".concat(a, "-").concat(b, ";s+=t*t;");
};

var pre = "let t,s=0;";

var $ = function $(dim) {
  return distSq.add(dim, compile(dim, tpl, "a,b", undefined, "s", "", pre));
};

export var distSq = vop();
distSq["default"](compileG(tpl, "a,b", undefined, "s", pre));
export var distSq2 = $(2);
export var distSq3 = $(3);
export var distSq4 = $(4);